/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * A definition of material flows known to the system
 */
export enum EnumMaterialFlow {
    /**
     * Not defined
     */
    NotDefined = 0,
    /**
     * Denotes a process where material is incoming
     */
    Incoming = 1,
    /**
     * Denotes a process where material is outgoing
     */
    Outgoing = 2,
    /**
     * Denotes a process where material is transported
     */
    Transport = 3,
    /**
     * Denotes a process where material is weighed in a foreign location
     */
    ForeignWeighing = 4,
    /**
     * Denotes a process that does not involve any service
     */
    Empty = 5,
    /**
     * Denotes a process which performs a control weighing
     */
    Control = 6,
    /**
     * Denotes a process where material is traded
     */
    Trade = 7,
    /**
     * Denotes a process where material is purchased
     */
    Purchase = 8,
    /**
     * Denotes a process where material is sold
     */
    Sale = 9,
}
